import { KOMBINATION_OPENAPI_URL } from "../components/brand";

const apis = [
    // {    
    //   type: "file",
    //   input: "./apis/openapi.yaml",
    //   path: "/api-admin",
    //   // Configure server settings for API docs
    //   config: {
    //     tryItOut: {
    //       corsProxy: false, // Disable CORS proxy for local file
    //     },
    //   },
    // },
    {    
      type: "file",
      input: "./apis/prod.v1.yaml",
      path: "/api",
      // Configure server settings for API docs
      config: {
        tryItOut: {
          corsProxy: false, // Disable CORS proxy for local file
        },
      },
    },
    {
      type: "url",
      input: KOMBINATION_OPENAPI_URL,
      path: "/api-kombination",
      // Configure server settings for API docs
      config: {
        tryItOut: {
          corsProxy: false, // Disable CORS proxy for local file
        },
      },
    }
  ] as const;

export default apis;